module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n"
  }, [_c('span', [_vm._v("1")])]), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GING")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH")])])]), _c('h1', {
    staticClass: "chap_stit"
  }, [_c('span', [_vm._v("A Future Katrina?")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("Storms like Hurricane Katrina wash away the surface of society, the settled way things have been done. They expose the underlying power structures, the injustices, the patterns of corruption and the unacknowledged inequalities.")])]), _c('p', {
    staticClass: "auteur"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROOKS")]), _vm._v(", "), _c('i', [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("HE ")])]), _c('i', [_vm._v("N")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("EW ")])]), _c('i', [_vm._v("Y")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("ORK ")])]), _c('i', [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("IMES")])])])])]), _c('div', {
    staticClass: "chapeau"
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "image",
      "id": "sep_3",
      "src": "images/sep.jpg"
    }
  })])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("M")]), _vm._v("ajor catastrophes like 9/11, Hurricane Katrina and the 2008 Haitian earthquake can serve as a wakeup call to individuals, families, communities and nations about the necessity of being prepared. These events also reveal clearly that seniors suffer disproportionately during natural disasters.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#ntb-001",
      "id": "ap_ntb-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" From the now-forgotten tragedy of the flooded nursing home in New Orleans to the abandoned nursing home in Haiti, the higher mortality rates among seniors found in China and Japan serve as tragic reminders that our old people are vulnerable during disasters. Dr. Parker led an interdisciplinary team in New Orleans that helped con"), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("gregations to use geographic information systems able to map patterns of vulnerability in advance, allowing first responders to intervene more effectively. Congregations can provide help to their older members through proactive planning, using “go kits,” multitiered evacuation plans, contact information with families, lists of relevant health care providers, a week’s supply of prescriptions and over-the-counter medications, etc. Unfortunately, his most recent research confirms that congregations do not think about helping their elderly members prepare in a systematic, proactive way for high probability disasters in their geographic locations (e.g., fires, power outages, tornadoes).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Elderly disabled people with mobility limitations are particularly vulnerable in disasters. During 9/11, before the Twin Towers collapsed, people in wheelchairs were systematically evacuated to a midlevel staging area, essentially condemning them to death. Only one seriously disabled person was successfully evacuated before the towers collapsed. She later shared what the fireman who was carrying her down the stairs said after he looked at the faces of people sitting in their wheel chairs: “Lady, I ain’t leaving you here!”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#ntb-002",
      "id": "ap_ntb-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" We need that kind of honest assessment and commitment to do the necessary work in the church today, and elders should be a vibrant, essential part of this effort.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Hurricane Katrina was different from 9/11 and the Haitian and Chinese earthquakes and the more-recent tsunami that hit Japan because of advance warning. Yet despite the opportunity to prevent some of the hurricane’s devastation, vulnerable members of the community were lost. When the water rose to the rooftops in New Orleans, many citizens drowned, including, as is well-publicized, the entire resident population of one nursing home. Although many able-bodied people had evacuated safely prior to Hurricane Katrina’s landfall, thousands remained in their homes, either refusing or unable to evacuate. Many others died as a consequence of the way they were evacuated. This was particularly true of those over sixty-five. Roughly one half of New Orleans’ poor households did not own a vehicle, and among New Orleans’ "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("elderly population, 65 percent were without vehicles.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("When the levees (walls) protecting the city fractured, large parts of New Orleans and nearby Louisiana parishes were destroyed. Approximately ninety thousand square miles of the Gulf Coast, an area roughly the size of Great Britain, was declared a federal disaster area. Katrina exposed the stench of societal neglect, injustice and inequality in one of our nation’s poorest cities. After the hurricane made landfall, contaminated floodwaters covered much of New Orleans for almost two months. Health concerns were elevated for residents and cleanup workers because the polluted waters contained a mix of raw sewage, dead bodies, bacteria, millions of gallons of oil, heavy metals, pesticides and toxic chemicals.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#ntb-003",
      "id": "ap_ntb-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Over a thousand people in the New Orleans area would die as a result of Hurricane Katrina. Seventy four percent were over sixty years old; 50 percent were over age seventy-five. These proportions are shockingly high, considering the fact that the elderly constituted only 11.7 percent of New Orleans’ population.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The disproportionate number of elderly deaths during Hurricane Katrina may seem unrelated to the church at large. But consider, however, that in most communities, more than 95 percent of the elderly do not live in nursing homes, yet approximately 80 percent are members of religious congregations. In subsequent chapters, we present a more thorough examination of the problem of connecting elderly church members with the younger members in a church. Yet the example of Katrina begs the question, why were frail elderly and disabled people without the capacity to evacuate themselves during Hurricane Katrina not helped by more able-bodied members of their congregations? If the fastest-growing age group is eighty-five and older, and almost half in this age group suffer from dementia, why didn’t the congregations of the elderly who needlessly perished during Katrina play a more proactive role in rescuing their own and others in the city of New Orleans?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Perhaps it is because the effects of aging on a person, a family, a congregation, a community and a nation are typically experienced more subtly and insidiously. Perhaps, like other institutions (political, medical, marketing and entrepreneurial), the church is both actively and clandestinely ageist. Like other “isms” (such as racism), "), _c('i', [_vm._v("ageism")]), _vm._v(" is a self-defeating societal ill that has many forms of expression. Simply stated, it is the presence of negative stereotypes, incorrect assumptions and distorted characterizations about older people and their capacities. Chapter twelve debunks some myths about aging by examining the latest research, but here we explore what researchers have found in some instances: the presence of ageist attitudes and practices actually shortens the quality and length of the lives of older persons and their contributions to society. Hurricane Katrina presents a severe case, in which many improperly evacuated older and disabled persons died.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Examples of Ageism ")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Do some churches—or, at least, people in positions of power or influence within them—view older people as selfish, dependent, helpless and unable to contribute? In truth, the vast majority of seniors are active consumers who have more assets than younger people and possess a great deal of available talent, training and (perhaps) time. Most important, many older persons have years of experience in living out their faith. This gives them a unique capacity to represent the love of Christ to others. Our research indicates clearly that though ageism exists in the modern church, many church leaders want to do something about it.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#ntb-004",
      "id": "ap_ntb-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Ageism is not just another issue churches need to be conscious of but a neglectful sin that has resulted in the loss of life of older members.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One specific example of ageism is a widespread tendency to design ministries and Sunday school classes around age-graded thinking. "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("While eighty-five-year-olds can be “younger” (more vivacious) than some eighteen-year-olds both psychologically and spiritually, separating believers by their ages deprives everyone of the chance to learn from and care for each other across ages. Like the decision to place disabled people on a midlevel floor after the 9/11 attack, such a decision has a profoundly negative effect on older saints and makes fostering intergenerational connections almost impossible during the Sunday school hour. Given the high divorce rate within the modern church, for example, newly married young couples might benefit from association with older couples, some of whom have been married for over fifty years.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("In another example of ageism, recent research suggests that pastors stop visiting elderly members of their congregations who reside in long term care facilities once they detect or have confirmed that a resident is suffering from dementia.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen12#ntb-005",
      "id": "ap_ntb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Because almost half of those who reach eighty-five or older will suffer from a form of dementia, believers must encourage the church to view these senior members as people with tremendous value. Anyone who is rendered helpless and dependent still has worth in the eyes of Christ. Learning to love under these circumstances can carry a price for those extending the love, and the church must be there to help caregivers and care recipients in ways that make a real difference. Platitudes or promises of prayer cannot replace the necessity of practical forms of assistance and state of science care. The biblical truth that receiving often follows giving holds true in such circumstances. Those who lovingly serve older people incapable of returning their love will be blessed through their efforts many times over because they learn how to love unconditionally. Though corporate sins of neglect are largely sins of omission, only the church can preach the God-given value of those who are losing their intellectual capacities and foster the spiritual growth available to their caregivers.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One senior pastor of a large Presbyterian church characterized his seniors in categories “no go, slow go and fast go: If someone is a "), _c('i', [_vm._v("no go")]), _vm._v(", she tends to be frail and demented, dependent upon others, while the "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('i', [_vm._v("fast go ")]), _vm._v("is strong and independent; a "), _c('i', [_vm._v("slow go")]), _vm._v(" is somewhere in between.” The church should ask the hard question, what value to society is a “no go”? And we should answer confidently, “An incontinent, dependent, person suffering from late stage Alzheimer’s disease provides the person’s family and her church with one of life’s most important lessons, an opportunity to learn how to love a person unconditionally, without any expectation of something in return.” Because dementia care is complicated and challenging, we discuss how the church can help develop caregiver support groups and maintain directories of community-based and national resources in a later chapter.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Senior Ministry: Both To and From ")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Although the health status of aging members does affect the type of ministry extended to them or expected from them, the church must confront the reality that almost all members must be included in some type of ministry. In the coming years, it will become more and more crucial to create connections with aging members; in fact, it is a biblical responsibility to maintain cutting edge ministries “to” and “from” elders.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Like the failed faith-based system in New Orleans, if the church ignores and mishandles its aging members, the effects can have a devastating outcome. As we will learn in subsequent chapters, our society in general is unprepared for its aging population as disasters have revealed. If our society fails to train our religious, medical, legal, financial and entrepreneurial leaders about these matters, systems of support will be like a broken levee, unable to deal with the multiplying needs in elder care. The church of all institutions needs to take a stand. Sadly it may be the least prepared.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("We need older persons of faith to help us address the problems we face today individually, as families, as members of our communities and as citizens of great nations. We cannot afford to deny and minimize the facts concerning the elderly, perpetuate our rationalizations about them, and project our personal and religious responsibilities toward them onto other people and institutions. Christ warned us about the consequences of losing that which places and preserves faith in him in the Sermon on the Mount. “You are the salt of the earth. But if the salt ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("loses its saltiness, how can it be made salty again? It is no longer good for anything, except to be thrown out and trampled by men. You are the light of the world. A city on a hill cannot be hidden. Neither do people light a lamp and put it under a bowl. Instead they put it on its stand, and it gives light to everyone in the house. In the same way, let your light shine before men, that they may see your good deeds and praise your father in heaven” (Mt 5:13-16). If the church continues to relegate its responsibilities toward its senior members to other institutions in society and fails to recognize the gifts that lay within those members, it will become like salt that has lost its taste, its purpose and its capacity to preserve that which is good, and it will have lost its capacity to light the way. The aging church is not an accident. It is God himself who has granted longer life for his purposes, and we believe that elders hold the keys to solving many, if not most, of society’s problems.")])])])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 75
// module chunks = 0